import React, { useEffect, useRef, useState } from "react";
import { Slide } from "react-awesome-reveal";
import Modal from "../../../components/modal";
import WrQues from "./WrQues/WrQues";
import TopBar from "../../../components/topbar";
import BottomBar from "../../../components/bottomBar";

const MobileWRQS = () => {
  const videoRef = useRef();

  const [isPlayed, setIsPlayed] = useState(true);
  const [toTry, setToTry] = useState(false);
  const [finishCheck, setFinishCheck] = useState(false);
  const [finished, setFinished] = useState(false);
  const [checkedLi, setCheckedLi] = useState(null);
  let [currentTweet, setCurrentTweet] = useState(0);
  const [validAnswer, setValidAnswer] = useState(null);
  const [validAnswers, setValidAnswers] = useState([]);
  useEffect(() => {
    if (videoRef.current)
      videoRef.current.addEventListener("ended", () => {
        setIsPlayed(false);
      });
  }, [videoRef.current]);
  useEffect(() => {
    if (finished) {
      console.log(validAnswers);
      setFinished(false);
    }
  }, [finished]);

  return (
    // <div>

    <div direction="right" className="slideFeatures">
      <div class="device">
        <TopBar />
        {toTry ? (
          <WrQues />
        ) : (
          <div className="video" style={{ marginTop: "0", height: "87%" }}>
            <video
              ref={videoRef}
              src={require("../../../Assets/videos/WQS.mp4")}
              muted
              autoPlay
              controls
            ></video>
            {isPlayed ? null : (
              <div className="video_overLay">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setIsPlayed(true);
                    videoRef.current.play();
                  }}
                >
                  Replay
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setToTry(true);
                  }}
                >
                  Try
                </button>
              </div>
            )}
          </div>
        )}
        <BottomBar />
      </div>
    </div>
    // </div>
  );
};

export default MobileWRQS;
